import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { TextCell } from '../../components/TextCell/TextCell';
import { MarketerProductAccessCellContainer } from '../../containers/MarketerProductAccessCellContainer/MarketerProductAccessCellContainer';
import { MarketerProductRemoveCellContainer } from '../../containers/MarketerProductRemoveCellContainer/MarketerProductRemoveCellContainer';
import { GridCellProps, GridColumnDecl } from '../../typings/grid';
import { MarketerProductsCellItem } from '../../typings/marketers';

import * as keyset from './marketerProducts.i18n';

const i18n = i18nFactory(keyset);

export enum MarketerProductsColumnKeys {
    ID = 'id',
    PRODUCT_NAME = 'product-name',
    ACCESS = 'access',
    REMOVE = 'remove'
}

const WIDTH_ID = 100;
const WIDTH_PRODUCT_NAME = 250;
const WIDTH_ACCESS = 120;
const WIDTH_REMOVE = 50;

const tableCellMarketerProductId: GridColumnDecl<MarketerProductsCellItem> = {
    title: i18n('id'),
    key: MarketerProductsColumnKeys.ID,
    width: WIDTH_ID,
    isResizable: false,
    isSortable: true,
    flexGrow: 1,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<MarketerProductsCellItem>) => (
            <div>{item.id}</div>
        )
    )
};

const tableCellMarketerProductName: GridColumnDecl<MarketerProductsCellItem> = {
    title: i18n('product-name'),
    key: MarketerProductsColumnKeys.PRODUCT_NAME,
    width: WIDTH_PRODUCT_NAME,
    isResizable: false,
    isSortable: true,
    flexGrow: 2,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<MarketerProductsCellItem>) => (
            <TextCell>{item.productName}</TextCell>
        )
    )
};

const tableCellMarketerProductAccess: GridColumnDecl<
    MarketerProductsCellItem
> = {
    title: i18n('access'),
    key: MarketerProductsColumnKeys.ACCESS,
    width: WIDTH_ACCESS,
    isResizable: false,
    isSortable: false,
    flexGrow: 2,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<MarketerProductsCellItem>) => (
            <MarketerProductAccessCellContainer {...item} />
        )
    )
};

const tableCellMarketerProductRemove: GridColumnDecl<
    MarketerProductsCellItem
> = {
    title: '',
    key: MarketerProductsColumnKeys.REMOVE,
    width: WIDTH_REMOVE,
    isResizable: false,
    isSortable: false,
    cellClass: 'marketer-products-vertically-centred',
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<MarketerProductsCellItem>) => (
            <MarketerProductRemoveCellContainer {...item} />
        )
    )
};

export function getMarketerProductsListItem(): GridColumnDecl<
    MarketerProductsCellItem
>[] {
    return [
        tableCellMarketerProductId,
        tableCellMarketerProductName,
        tableCellMarketerProductAccess,
        tableCellMarketerProductRemove
    ];
}
